module.exports = __webpack_public_path__ + "img/bsg-pro-bedroom2024.943283f5.png";